import React, { useState, useEffect } from 'react';
import Searchsection from './searchsection/searchsection';
import Dashboardsection from './dashboardsection/dashboardsection';
import Headersection from './headersection/headersection';
import BodySection from './bodysection/bodysection';
import YearSection from './yearsection/yearsection';
import Pricing from './pricingsection/pricingsection';
import ContactSection from './contactsection/contactsection';
import PopupFilters from './searchsection/searchfilters';
import CareerGuidanceHomepage from './careerguidance/careerGuidanceHomepage';
import '@fortawesome/fontawesome-free/css/all.min.css';

const HomePage = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const savedPosition = sessionStorage.getItem("initialScrollPosition");
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition, 10));
      sessionStorage.removeItem("initialScrollPosition");
    }
  }, []);


  const handleSearchFocus = () => {
    setShowPopup(true);
  };
  return (
    <div className="fluid-container">
      <Headersection />
      <Searchsection onSearchFocus={handleSearchFocus} />
      <PopupFilters showPopup={showPopup} setShowPopup={setShowPopup} />
      <Dashboardsection />
      <YearSection />
      <BodySection />
      <Pricing page="homepage" />
      <ContactSection />

    </div>
  );
};

export { HomePage };
